import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BreakPointService, Device } from '@woolworthsnz/styleguide';
import { DropdownComponent } from '@woolworthsnz/form';
import { RecipeListRequest, SortOptionItem } from '@woolworthsnz/trader-api';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';

@Component({
	selector: 'recipe-sort-header',
	template: `
		<div class="recipeSort-container">
			<form-dropdown
				class="recipeSort-sortBy"
				data-cy="sortBy-dropdown"
				name="sortBy-dropdown"
				labelText="Sort by"
				[list]="sortOptions"
				(onSelect)="sortChange.emit($event)"
				[selectedValue]="currentSortOption"
				[fullWidth]="isMobile$ | async"
				[constrainWidth]="!(isMobile$ | async)"
			></form-dropdown>
		</div>
	`,
	styleUrls: ['./sort-header.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [DropdownComponent, AsyncPipe]
})
export class SortHeaderComponent {
	@Input() currentSortOption: RecipeListRequest.SortEnum;
	@Input() sortOptions: SortOptionItem[] = [
		{ text: 'Latest', value: 'Latest' },
		{ text: 'Oldest', value: 'Oldest' },
	];

	@Output() sortChange = new EventEmitter<string>();

	isMobile$: Observable<boolean>;

	constructor(private breakPointService: BreakPointService) {
		this.isMobile$ = this.breakPointService.device$.pipe(map((device) => device === Device.MOBILE));
	}
}
